import { useState } from "react";

export const FakeLogin = ({clickHandler}) => {
  const [user, setUser] = useState("");
  const [pwd, setPwd] = useState("");

  // Event handler to update the state when the input changes
  const handleInputChange = (event) => {
    setUser(event.target.value);
  };
  const handlePwd = (event) => {
    setPwd(event.target.value);
  };


  return (
    <div className="w-screen h-screen bg-white z-50 fixed flex items-center justify-center">
      <div className="w-[40vw] h-[50vh] border-2 border-primary p-20">
        <div>Please, enter username and password to use this archive</div>

        <div className="flex flex-col my-10">
          <input
            type="text"
            value={user}
            onChange={handleInputChange}
            placeholder="Username"
            className="border-[1px] border-solid border-primary mb-5"
          />
          <input
            type="password"
            value={pwd}
            onChange={handlePwd}
            placeholder="Password"
            className="border-[1px] border-solid border-primary"
          />
        </div>
        <button onClick={()=>clickHandler(user,pwd)} className={`py-1.5 px-5 lg:px-11 border-[1px]  border-solid border-primary hover:text-white whitespace-nowrap uppercase`}>Log</button>
      </div>
    </div>
  );
};
